import React, { FC } from 'react';
import { BasicContainer, FlexCol, Loader } from '@minecraft.atoms';
import { PlanSm } from '../PlanSelection/PlanSm';
import { CheckoutHead } from './CheckoutHead';
import { VerticalPlans } from './VerticalPlans';
import { VerticalPlanLoader } from './VerticalPlansLoader';
import { CheckoutProps } from './types';
import { MediaPurchase } from '../enums/plans';

export interface CheckoutPlansProps {
  onNext: () => void;
  onBack?: () => void;
  isAnnual: CheckoutProps['isAnnual'];
  plans: CheckoutProps['plans'];
  plansError: CheckoutProps['plansError'];
  plansLoading: CheckoutProps['plansLoading'];
  setIsAnnual: CheckoutProps['setIsAnnual'];
  selectedPlan: CheckoutProps['selectedPlan'];
  setSelectedPlan: CheckoutProps['setSelectedPlan'];
  countryCode: CheckoutProps['countryCode'];
  isPlanVisible: boolean;
  startingStep: CheckoutProps['startingStep'];
  isModal: CheckoutProps['isModal'];
  getTitle: CheckoutProps['getTitle'];
  showPaymentMethods: boolean;
  setShowPaymentMethods: (show: boolean) => void;
  startsAtCheckoutMobile: boolean;
  handleBack: (_: React.MouseEvent<HTMLElement>) => void;
  isHeaderHidden?: boolean;
  currentPlanCode?: CheckoutProps['currentPlanCode'];
  paywallLocation?: CheckoutProps['paywallLocation'];
  isWithinTrialPeriod?: CheckoutProps['isWithinTrialPeriod'];
  previewMediaPurchase?: CheckoutProps['previewMediaPurchase'];
  previewMediaPurchaseLoading?: CheckoutProps['previewMediaPurchaseLoading'];
  isAnnualToggleLocked?: CheckoutProps['isAnnualToggleLocked'];
}

export const CheckoutPlans: FC<CheckoutPlansProps> = React.memo(
  ({
    onNext,
    isAnnual,
    plans,
    plansError,
    plansLoading,
    setIsAnnual,
    selectedPlan,
    setSelectedPlan,
    countryCode,
    isPlanVisible,
    startingStep,
    showPaymentMethods,
    setShowPaymentMethods,
    startsAtCheckoutMobile,
    handleBack,
    isHeaderHidden = false,
    currentPlanCode,
    paywallLocation,
    isWithinTrialPeriod,
    previewMediaPurchase,
    previewMediaPurchaseLoading,
    isAnnualToggleLocked,
  }) => {
    return (
      <Loader loading={!plans.length || plansLoading} LoaderComponent={<VerticalPlanLoader />}>
        <FlexCol gap="4" mb="8">
          {!isHeaderHidden && (
            <BasicContainer mx="1">
              <CheckoutHead
                isAnnual={isAnnual}
                setIsAnnual={setIsAnnual}
                isToggleLocked={selectedPlan?.billingCode === MediaPurchase.alacarte || isAnnualToggleLocked}
                purchaseableItems={previewMediaPurchase?.items}
                plans={plans}
                countryCode={countryCode}
                currencyCode={previewMediaPurchase?.currency?.code}
              />
            </BasicContainer>
          )}
          {!showPaymentMethods && startsAtCheckoutMobile && (
            <PlanSm
              onNext={onNext}
              setShowPaymentMethods={setShowPaymentMethods}
              plans={plans}
              isAnnual={isAnnual}
              setIsAnnual={setIsAnnual}
              selectedPlan={selectedPlan}
              setSelectedPlan={setSelectedPlan}
              countryCode={countryCode}
              isCompletePurchase
              onBack={handleBack}
              startingStep={startingStep}
              paywallLocation={paywallLocation}
            />
          )}
          {isPlanVisible && (
            <VerticalPlans
              isAnnual={isAnnual}
              plans={plans}
              plansError={plansError}
              plansLoading={plansLoading}
              setIsAnnual={setIsAnnual}
              selectedPlan={selectedPlan}
              countryCode={countryCode}
              onNext={onNext}
              setSelectedPlan={setSelectedPlan}
              startingStep={startingStep}
              currentPlanCode={currentPlanCode}
              paywallLocation={paywallLocation}
              isWithinTrialPeriod={isWithinTrialPeriod}
              previewMediaPurchase={previewMediaPurchase}
              previewMediaPurchaseLoading={previewMediaPurchaseLoading}
            />
          )}
        </FlexCol>
      </Loader>
    );
  }
);
